
import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class RepairBanner extends React.Component {
	render() {
		return ( 
            <div className="repair-container">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h2>Har din cykel brug for eftersyn eller reparation?</h2>
                            <p>Vi vil gøre det!</p>
                            <Link to="/repairs" className="btn btn-default btn-lg">Læs Mere</Link>
                        </div>
                    </div>
                </div>
            </div>
		);
	}
}

export default RepairBanner;


// WEBPACK FOOTER //
// ./src/Components/RepairBanner.js